module.exports = __webpack_public_path__ + "static/media/explore.3d4dfc2c.jpg";